<template>
  <div class="card additional-info">
    <div class="promotion-block">
      <h2>
        {{ headerText }}
      </h2>
      <p>
        {{ bodyText }}
      </p>

      <div class="promo-action-buttons">
        <a-button class="secondary-button" @click="showFeedbackForm">
          Получить консультацию
        </a-button>

        <a-button class="secondary-button" @click="openLink">
          Читать блог
        </a-button>
      </div>
    </div>
  </div>
  <pop-up-form title="Получить консультацию по продукту"
               :comment="'Хочу получить консультацию по продукту ' + consultCommentProduct"
               v-if="openConsultModal"
               @closeModal="openConsultModal = false" />
</template>

<script>

import {useStore} from "vuex";
import PopUpForm from "@/components/Popups/PopUpForm.vue";
import {ref} from "@vue/runtime-core";

export default {
  components: {PopUpForm},
  props: {
    consultCommentProduct: {
      type: String,
      default: "",
    },
    headerText: {
      type: String,
      default: "Что делать с результатами?",
    },
    bodyText: {
      type: String,
      default: "Вы собрали и изучили данные о команде. Чтобы перевести эти цифры в план развития, обсудите результаты с экспертом. Идеи для упражнений и статьи об ЭИ — в нашем блоге.",
    }
  },
  setup() {
    const store = useStore();
    const openConsultModal = ref(false);

    const openLink = () => {
      window.open('https://way2wei.ru/media-center', '_blank');
    }

    const showFeedbackForm = () => {
      // store.commit("support/showForm");
      openConsultModal.value = true;
    };

    return {
      openLink,
      showFeedbackForm,
      openConsultModal
    }
  }
}
</script>

<style scoped lang="scss">
.additional-info {
  padding: 20px;
}

h2 {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  margin-bottom: 12px;
}

.promotion-block {
  max-width: 800px;

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    margin-bottom: 20px;
  }

  .promo-action-buttons {
    display: flex;
    gap: 8px;

    @media (max-width: $mobile-breakpoint) {
      flex-direction: column;
    }
  }
}
</style>